import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { footer_links } from 'config';

const AccountTabsPublic = ({ currentPath = null }) => {

    const [selectedValue, setSelectedValue] = useState('');
    const [linkList, setLinkList] = useState([]);
    useEffect(() => {
        const linksConfig = [ 
            {
                url: footer_links.tienda.terms_condition_public, 
                title: 'Términos y condiciones', 
                target: '', 
                active: (footer_links.tienda.terms_condition_public===currentPath)
            }, 
            {
                url: footer_links.tienda.privacy_public, 
                title: 'Políticas de privacidad y seguridad', 
                target: '', 
                active: (footer_links.tienda.privacy_public===currentPath)
            },
            {
                url: footer_links.tienda.data_protecction_public, 
                title: 'Protección de datos personales', 
                target: '', 
                active: (footer_links.tienda.data_protecction_public===currentPath)
            },
            {
                url: footer_links.tienda.cookies_public, 
                title: 'Políticas de cookies', 
                target: '', 
                active: (footer_links.tienda.cookies_public===currentPath)
            }
        ];
        setLinkList(linksConfig);
        linksConfig.map( itm => {
            if(itm.active) setSelectedValue(itm.url);
            return itm;
        });
    }, []);

    return (
        <>
        <ul className="d-none d-lg-block" data-links={linkList.length}>
            {linkList.map( (link, key) => {
                return (
                    <li key={key} className={link.active ? 'active' : ''}>
                        {link.active
                            ?
                            <a>{link.title}</a>
                            :
                            <a href={link.url}>{link.title}</a>
                        }
                    </li>
                )
            })}
        </ul>
        <div className="row d-lg-none">
            <div className="col-12">
                <select  value={selectedValue} onChange={(e)=>setSelectedValue(e.target.value)} className="select2" name="dropDownListMenu">
                    {linkList.map( (option, key) => {
                        return <option key={key} value={option.url}>{option.title}</option>
                    })}
                </select>
            </div>
        </div>
        </>
    );
}

AccountTabsPublic.propTypes = {
    currentPath: PropTypes.string
};

export default AccountTabsPublic; 